import { render, staticRenderFns } from "./LoanTakeBackExplainModal.vue?vue&type=template&id=acc4ffb8&scoped=true&"
import script from "./LoanTakeBackExplainModal.vue?vue&type=script&lang=ts&"
export * from "./LoanTakeBackExplainModal.vue?vue&type=script&lang=ts&"
import style0 from "./LoanTakeBackExplainModal.vue?vue&type=style&index=0&id=acc4ffb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc4ffb8",
  null
  
)

export default component.exports